<template>
  <div class="h-10 w-24 animate-pulse rounded bg-gray-200" />
</template>
